export const NAME = 'questions';



// WEBPACK FOOTER //
// ./src/questions/constants.js